import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "transactions-section" };
const _hoisted_2 = { class: "section-content" };
const _hoisted_3 = { class: "section-title" };
const _hoisted_4 = { class: "day-groups" };
const _hoisted_5 = { class: "day-header" };
const _hoisted_6 = { class: "day-transactions" };
const _hoisted_7 = ["src"];
import { computed } from 'vue';
import RecentDiscountTransactionItem from './RecentDiscountTransactionItem.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DiscountTransactionsSection',
    props: {
        title: {},
        days: {},
        maxDays: {},
        maxVouchers: {},
        viewMoreText: { default: "View more" },
        formatter: {}
    },
    emits: ["view-more"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const filteredDays = computed(() => {
            const days = props.days ?? [];
            const filtered = days.filter(day => day.purchases && day.purchases.length > 0);
            return props.maxDays != null ? filtered.slice(0, props.maxDays) : filtered;
        });
        const hasMoreDays = computed(() => {
            if (props.maxDays == null && props.maxVouchers == null)
                return false;
            const days = props.days ?? [];
            const daysWithPurchases = days.filter(day => day.purchases && day.purchases.length > 0);
            const totalPurchases = daysWithPurchases.reduce((sum, day) => sum + day.purchases.length, 0);
            return (props.maxDays != null && daysWithPurchases.length > props.maxDays) ||
                (props.maxVouchers != null && totalPurchases > props.maxVouchers);
        });
        function getLimitedPurchases(day, dayIndex) {
            if (props.maxVouchers == null)
                return day.purchases;
            let countBefore = 0;
            for (let i = 0; i < dayIndex; i++) {
                countBefore += filteredDays.value[i].purchases.length;
            }
            const remaining = props.maxVouchers - countBefore;
            if (remaining <= 0)
                return [];
            return day.purchases.slice(0, remaining);
        }
        function formatDayHeader(dateString, count) {
            const date = new Date(dateString);
            const today = new Date();
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            const isToday = date.toDateString() === today.toDateString();
            const isYesterday = date.toDateString() === yesterday.toDateString();
            let dayLabel;
            if (isToday) {
                dayLabel = 'Today';
            }
            else if (isYesterday) {
                dayLabel = 'Yesterday';
            }
            else {
                const day = date.getDate();
                const month = date.toLocaleDateString('en-GB', { month: 'long' });
                dayLabel = `${day} ${month}`;
            }
            return `${dayLabel} (${count})`;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDays.value, (day, dayIndex) => {
                            return _withDirectives((_openBlock(), _createElementBlock("div", {
                                key: dayIndex,
                                class: "day-group"
                            }, [
                                _createElementVNode("p", _hoisted_5, _toDisplayString(formatDayHeader(day.date, day.purchases.length)), 1),
                                _createElementVNode("div", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getLimitedPurchases(day, dayIndex), (purchase, purchaseIndex) => {
                                        return (_openBlock(), _createBlock(RecentDiscountTransactionItem, {
                                            key: purchaseIndex,
                                            merchantName: purchase.merchantName,
                                            icon: purchase.icon,
                                            faceValue: purchase.faceValue,
                                            savedToSpendEarningsAmount: purchase.savedToSpendEarningsAmount,
                                            savingPercentage: purchase.savingPercentage,
                                            usedSavedToSpend: purchase.usedSavedToSpend,
                                            formatter: _ctx.formatter
                                        }, null, 8, ["merchantName", "icon", "faceValue", "savedToSpendEarningsAmount", "savingPercentage", "usedSavedToSpend", "formatter"]));
                                    }), 128))
                                ])
                            ])), [
                                [_vShow, getLimitedPurchases(day, dayIndex).length > 0]
                            ]);
                        }), 128))
                    ]),
                    (hasMoreDays.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "view-more-button",
                            onClick: _cache[0] || (_cache[0] = ($event) => (emit('view-more')))
                        }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.viewMoreText), 1),
                            _createElementVNode("img", {
                                src: require('@/assets/arrow-right.png'),
                                alt: "arrow",
                                class: "arrow-icon"
                            }, null, 8, _hoisted_7)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
